<div class="mx-auto md:w-2/3 w-full">
  <h1 class="font-bold text-4xl">Editing dance</h1>

  <%= render "form", dance: @dance %>

  <div class="mx-auto flex">
    <button type="submit" class="btn-blue" form="dance-form">Update Dance</button>
    <% unless @locked %>
    <%= button_to "Remove this dance", dance_path(@dance), method: :delete, class: "btn-grey my-0", form: { data: { turbo_confirm: "Are you sure?" } } %>
    <% end %>
    <%= link_to "Back to Dances", dances_path, class: "btn-grey my-0" %>
  </div>
</div>
